<template>
    <v-container>
        <v-form v-model="isValidWorkspace">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-text-field-filled
                        data-cy="accountingWorkspace-name"
                        v-model="accountingWorkspace.name"
                        label="Nom"
                        outlined
                        :rules="[(v) => !!v || 'Un nom est requis']"
                        :readonly="!enableWrite"
                        density="compact"
                    />
                </v-col>
            </v-row>
        </v-form>
        <v-row no-gutters>
            <v-col cols="3" style="border-right: 1px #eaeaea solid">
                <v-list nav density="compact" v-model:selected="selectedMenu">
                    <v-list-item
                        link
                        value="available-companies"
                        @click="setSelectedMenu('available-companies')"
                        id="Societe"
                    >
                        <template #prepend>
                            <v-icon size="small">$fa-building</v-icon>
                        </template>
                        <v-list-item-title>
                            <span class="subtitle-2">Sociétés affectées</span>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        link
                        value="available-workspace-users"
                        @click="setSelectedMenu('available-workspace-users')"
                    >
                        <template #prepend>
                            <v-icon size="small">$fa-user</v-icon>
                        </template>
                        <v-list-item-title>
                            <span class="subtitle-2">Utilisateurs affectés</span>
                        </v-list-item-title>
                    </v-list-item></v-list
                >
            </v-col>
            <v-col cols="9" class="pl-3">
                <v-window v-model="selectedMenu">
                    <v-window-item value="available-companies">
                        <v-row no-gutters class="pt-2">
                            <v-col cols="8" class="pr-2">
                                <v-text-field-filled
                                    data-cy="accountingWorkspace-search"
                                    v-model="searchCompany"
                                    label="Rechercher"
                                    outlined
                                    hide-details
                                    density="compact"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pt-2">
                            <template v-if="!filteredClientCompanies.length">
                                {{
                                    isFromUsersMenu
                                        ? "Aucune société trouvée"
                                        : "Aucun dossier trouvé"
                                }}
                            </template>
                            <v-col cols="12" class="mb-2">
                                <v-btn
                                    color="primary"
                                    elevation="0"
                                    class="mr-2"
                                    rounded
                                    :readonly="!enableWrite"
                                    size="small"
                                    @click="selectAllCompany()"
                                >
                                    Sélectionner tous les dossiers
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    elevation="0"
                                    rounded
                                    :readonly="!enableWrite"
                                    size="small"
                                    @click="diselectAllCompany()"
                                >
                                    Désélectionner tous les dossiers
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="6"
                                v-for="comp in filteredClientCompanies"
                                :key="comp.id"
                                class="pr-2 pb-2"
                            >
                                <div>
                                    <v-list-item
                                        ripple
                                        class="oss-list-item"
                                        data-cy="accountingWorkspace-item"
                                    >
                                        <!-- @click="clickedClientCompanies(comp)" -->
                                        <template #prepend>
                                            <v-checkbox
                                                data-cy="accountingWorkspace-itemCheckbox"
                                                v-model="selectedClientCompanies"
                                                :readonly="!enableWrite"
                                                :value="comp.id"
                                            />
                                        </template>

                                        <v-list-item-title data-cy="accountingWorkspace-title">
                                            <span>{{ comp.name }}</span>
                                        </v-list-item-title>
                                    </v-list-item>
                                </div>
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <v-window-item value="available-workspace-users">
                        <v-row no-gutters class="pt-2">
                            <v-col cols="8" class="pr-2">
                                <v-text-field-filled
                                    v-model="searchUser"
                                    label="Rechercher"
                                    outlined
                                    hide-details
                                    density="compact"
                                    append-inner-icon="$search"
                                    clearable
                                    @click:clear="searchUser = ''"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pt-2">
                            <template v-if="!filteredWorkspaceUsers.length">
                                Aucun utilisateur trouvé
                            </template>
                            <v-col cols="12" class="mb-2">
                                <v-btn
                                    color="primary"
                                    elevation="0"
                                    class="mr-2"
                                    rounded
                                    :readonly="!enableWrite"
                                    size="small"
                                    @click="selectAllUsers()"
                                >
                                    Sélectionner tous les utilisateurs
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    elevation="0"
                                    rounded
                                    :readonly="!enableWrite"
                                    size="small"
                                    @click="diselectAllUsers()"
                                >
                                    Désélectionner tous les utilisateurs
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="6"
                                v-for="user in filteredWorkspaceUsers"
                                :key="user.id"
                                class="pr-2 pb-2"
                            >
                                <v-list-item ripple class="oss-list-item" two-line>
                                    <!-- @click="clickedClientCompanies(comp)" -->
                                    <template #prepend>
                                        <v-checkbox
                                            v-model="selectedWorkspaceUsers"
                                            :readonly="!enableWrite"
                                            :value="user.id"
                                        />
                                    </template>
                                    <v-list-item-title>
                                        <span>{{ getUserDisplayName(user) }}</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ user.email }}
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
import CREATE_ACCOUNTING_WORKSPACE from "../../graphql/accountingWorkspace/CreateAccountingWorkspace.gql";
import UPDATE_ACCOUNTING_WORKSPACE from "../../graphql/accountingWorkspace/UpdateAccountingWorkspace.gql";
import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers2.gql";
import gql from "graphql-tag";
import { getUserDisplayName } from "../../services/userServices";
import { User } from "../../store/store";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["accountingWorkspaceCreated", "accountingWorkspaceUpdated"],
})
export class AccountingWorkspace extends Vue {
    @Prop({ default: null }) existingAccountingWorkspace: any;
    @Prop({ default: "" }) accountingFirmId: string;
    @Prop({ default: null }) actions: any;

    isValidWorkspace: boolean = false;

    accountingWorkspace = {
        id: "",
        name: "",
        clientCompanies: [],
        users: [],
    };

    selectedMenu = "";

    searchCompany = "";

    searchUser = "";

    filteredAccountingFirms = [];

    selectedClientCompanies = [];

    selectedWorkspaceUsers = [];

    get enableWrite() {
        return this.currentUser?.profile?.configuration?.accountingWorkspace?.write;
    }

    /**
     * Checks if the user is coming from the "/me/users" menu.
     * @returns {boolean} `true` if the previous route ends with "/me/users", otherwise `false`.
     */
    get isFromUsersMenu(): boolean {
        const previousRoute = this.$router.options.history.state.back as string;

        return previousRoute && previousRoute.endsWith("/me/users");
    }

    @Apollo({
        query: gql`
            query ($id: ID!) {
                company(where: { id: $id }) {
                    id
                    name
                    clientCompanies {
                        id
                        name
                    }
                }
            }
        `,
        variables() {
            return { id: this.$store.state.user.company.id };
        },
        skip() {
            return (
                !this.$store.state.user ||
                !this.$store.state.user.company.id ||
                !this.isAccountingUser
            );
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.company && data.company.clientCompanies) {
                    this.clientCompanies = data.company.clientCompanies;
                }
            }
        },
    })
    clientCompanies = [];

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.accountingFirmId,
                email_not: null,
            };
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.users) {
                    this.users = data.users;
                }
            }
        },
    })
    users: Array<any> = [];

    async beforeMount() {
        this.selectedClientCompanies = [];
        this.selectedWorkspaceUsers = [];

        this.accountingWorkspace = {
            id: "",
            name: "",
            clientCompanies: [],
            users: [],
        };

        if (this.existingAccountingWorkspace) {
            this.accountingWorkspace = this.existingAccountingWorkspace;

            if (
                this.existingAccountingWorkspace.clientCompanies &&
                this.existingAccountingWorkspace.clientCompanies.length
            ) {
                this.existingAccountingWorkspace.clientCompanies.forEach((cc) => {
                    if (!this.selectedClientCompanies.includes(cc.id)) {
                        this.selectedClientCompanies.push(cc.id);
                    }
                });
            }
            if (
                this.existingAccountingWorkspace.users &&
                this.existingAccountingWorkspace.users.length
            ) {
                this.existingAccountingWorkspace.users.forEach((u) => {
                    if (!this.selectedWorkspaceUsers.includes(u.id)) {
                        this.selectedWorkspaceUsers.push(u.id);
                    }
                });
            }
        }

        debugger;

        if (this.actions && this.actions.action) {
            this.actions.action.function = this.upsertAccountingWorkspace;
            this.actions.action.display = true;
            this.actions.action.loading = false;
            this.actions.action.disabled = () => {
                return !this.isValidWorkspace || !this.enableWrite;
            };
            this.actions.action.title = this.existingAccountingWorkspace ? "Modifier" : "Créer";
        }

        if (!this.accountingFirmId) {
            this.accountingFirmId = this.$store.state.user.company.id;
        }
    }

    async upsertAccountingWorkspace() {
        if (!this.existingAccountingWorkspace && this.enableWrite) {
            const createWorkspace = await this.$apollo.mutate({
                mutation: CREATE_ACCOUNTING_WORKSPACE,
                variables: {
                    name: this.accountingWorkspace.name,
                    accountingFirm: this.accountingFirmId ? this.accountingFirmId : null,
                    clientCompanies:
                        this.selectedClientCompanies && this.selectedClientCompanies.length
                            ? this.selectedClientCompanies.map((cc) => ({ id: cc }))
                            : [],
                    users:
                        this.selectedWorkspaceUsers && this.selectedWorkspaceUsers.length
                            ? this.selectedWorkspaceUsers.map((u) => ({ id: u }))
                            : [],
                },
            });

            if (createWorkspace.data.createAccountingWorkspace) {
                this.accountingWorkspace = createWorkspace.data.createAccountingWorkspace;
                this.$emit("accountingWorkspaceCreated", this.accountingWorkspace);
                this.accountingWorkspace = {
                    id: "",
                    name: "",
                    clientCompanies: [],
                    users: [],
                };
                this.selectedClientCompanies = [];
                this.selectedWorkspaceUsers = [];
            }
        } else {
            if (this.existingAccountingWorkspace.id) {
                const updatedAccountingWorkspace = await this.$apollo.mutate({
                    mutation: UPDATE_ACCOUNTING_WORKSPACE,
                    variables: {
                        id: this.existingAccountingWorkspace.id,
                        name: this.accountingWorkspace.name,
                        clientCompanies:
                            this.selectedClientCompanies && this.selectedClientCompanies.length
                                ? this.selectedClientCompanies.map((cc) => ({ id: cc }))
                                : [],
                        users:
                            this.selectedWorkspaceUsers && this.selectedWorkspaceUsers.length
                                ? this.selectedWorkspaceUsers.map((u) => ({ id: u }))
                                : [],
                    },
                });

                if (updatedAccountingWorkspace.data.updateAccountingWorkspace) {
                    this.accountingWorkspace =
                        updatedAccountingWorkspace.data.updateAccountingWorkspace;
                    this.$emit("accountingWorkspaceUpdated", this.accountingWorkspace);
                    this.accountingWorkspace = {
                        id: "",
                        name: "",
                        clientCompanies: [],
                        users: [],
                    };
                }
            }
        }
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get filteredClientCompanies() {
        const clientCompanies = this.clientCompanies;
        debugger;
        if (this.searchCompany !== "") {
            return clientCompanies
                .filter((x) => x.name.toLowerCase().includes(this.searchCompany.toLowerCase()))
                .sort((a, b) => a.name.localeCompare(b.name));
        }
        const result = clientCompanies.sort((a, b) => a.name.localeCompare(b.name));
        debugger;
        return result.filter((x) => this.hasRight(x) && this.isAvailableCompanies(x.id));
    }

    get filteredWorkspaceUsers() {
        const availableUsers = [];

        if (this.users?.length) {
            for (const user of this.users) {
                availableUsers.push(user);
            }
        }

        debugger;

        if (this.searchUser === "") {
            return availableUsers;
        } else {
            return availableUsers.filter(
                (x) =>
                    x.lastname.toLowerCase().includes(this.searchUser.toLowerCase()) ||
                    x.firstname.toLowerCase().includes(this.searchUser.toLowerCase()),
            );
        }
    }

    setSelectedMenu(text: string) {
        this.selectedMenu = text;
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    selectAllCompany() {
        this.selectedClientCompanies = this.filteredClientCompanies.map((cc) => cc.id);
    }

    diselectAllCompany() {
        this.selectedClientCompanies = [];
    }

    selectAllUsers() {
        this.selectedWorkspaceUsers = this.filteredWorkspaceUsers.map((u) => u.id);
    }

    diselectAllUsers() {
        this.selectedWorkspaceUsers = [];
    }

    hasRight(company) {
        const userWithRoles = company.companyUsers?.filter((cu) => cu.role && cu.user);
        if (userWithRoles?.length) {
            return !!userWithRoles.find((cu) => cu.user.id === this.currentUser.id);
        }
        if (!this.currentUser.profile) {
            return false;
        }
        if (this.currentUser.isAccountingEmployee) {
            return !!this.currentUser.allAvailableCompanies?.find((ac) => ac.id === company.id);
        }
        return true;
    }

    isAvailableCompanies(companyId) {
        const companyIndex = this.currentUser.allAvailableCompanies.findIndex(
            (x) => x.id === companyId,
        );
        if (companyIndex !== -1) {
            return true;
        }
        return false;
    }
}

export default toNative(AccountingWorkspace);
</script>
